module.exports = __webpack_public_path__ + "img/dots.a7ab4801.svg";